import React from 'react';
import { Box, alpha } from '@mui/material';
import { Loading } from './Loading';

interface LoadingProps {
  width?: number;
  height?: number;
  topPercent?: number;
  leftPercent?: number;
  isLoading?: boolean;
}

class LoadingMaskComponent extends React.Component<LoadingProps> {
  public render(): React.JSX.Element {
    const { isLoading } = this.props;
    return (
      <Box
        sx={(theme) => ({
          position: 'absolute',
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          backgroundColor: alpha(theme.palette.background.paper, 0.6),
          zIndex: 998,
          display: isLoading !== undefined && !isLoading ? 'none' : 'block',
        })}
      >
        <Loading {...this.props} />
      </Box>
    );
  }
}

export const LoadingMask = LoadingMaskComponent;
